export default function CTA() {
  return (
    <div className="bg-gradient-to-r from-purple-600 to-indigo-600 rounded-2xl p-6 text-center shadow-lg">
      <h3 className="text-xl font-bold text-white mb-3">
        ✨ Descubra Seu Mapa Astral Personalizado
      </h3>
      <p className="text-purple-100 mb-4">
       Crie seu mapa astral único e descubra os segredos do seu destino!
      </p>
      <a 
        href="https://dikaastral.com" 
        target="_blank" 
        rel="noopener noreferrer"
        className="inline-block bg-white text-purple-600 px-6 py-3 rounded-full font-semibold hover:bg-purple-50 transition-colors duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
      >
        🌟 Criar Meu Mapa Astral
      </a>
      <p className="text-purple-200 text-sm mt-3">
        Análise completa do seu mapa natal • Compatibilidade • Trânsitos planetários
      </p>
    </div>
  )
}